<template>
    <p @mousedown="handleClick" @touchend.prevent="handleClick" class="scrambleLink-wrapper"><span class="scrambleLink" @mouseenter="mouseOver"><ScrambleText :playAudio="false" ref="childRef" :text="msg" /></span></p>
</template>

<script>
    import ScrambleText from './ScrambleText.vue'
    export default {
        name: 'ScrambleTextLink', 
        props: {
            msg: {
                type: String,
                required: true,
            },
            linkTo: {
                type: String,
                required: true,
            }
        },
        components: {
            ScrambleText
        },
        methods: {
            mouseOver() {
                this.$refs.childRef.initScramble();
            },
            handleClick() {
                if (this.$refs.childRef) {
                    this.$refs.childRef.stop();
                }
                this.$router.push(this.linkTo);
            }
        }
    }
</script>

<style scoped>
    p {
        font-size: 1rem;
        padding-top: 1rem;
    }

    .scrambleLink-wrapper {
        cursor: pointer;
    }
    
    .scrambleLink:hover {
        font-weight: bold;
        color: inherit;
    }

    .scrambleLink {
        text-decoration: none;
        color: inherit;
        text-shadow: 3 3 180px rgb(250 219 255 / 35%), 0 0 32px rgb(205 120 255 / 34%);
    }
</style>